<div class="container">
    <div class="policy">
        <h3 style="width:100%;font-size:20px;text-align: center;">Privacy Policy</h3>
        <p style="width:100%;margin:10px 0">Io sottoscritto autorizzo il trattamento dei miei dati personali secondo l'attuale regolamentazione europea sul trattamento dei dati al fine di poter ricevere il servizio di consulenza previsto.</p>
        <!-- <p style="width:100%;margin-bottom:10px;">(Puoi trovare la policy completa su: https://www.beautyassistant.it/privacy-policy).</p> -->
        <button type="button" class="btn btn-primary" (click)="back()">Back</button>
    </div>
</div>
